// 텔레그램 링크 설정
// .env 파일의 REACT_APP_TELEGRAM_LINK 값을 사용합니다
// 기본값이 없을 경우를 대비한 fallback

export const TELEGRAM_LINK = process.env.REACT_APP_TELEGRAM_LINK || 'https://t.me/your_telegram_username';
